/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { apiClient } from '../../../lib/apiClient';
import formatDate from '../../../utils/formatDate';

export const getAddress = createAsyncThunk('arizonaAddresses/getAddress', async (id) => {
  const { data } = await apiClient.get(`/api/arizonaAddresses/${id}`);
  return data;
});

export const updateAddress = createAsyncThunk(
  'arizonaAddresses/updateAddress',
  async (editAddressObj, { rejectWithValue }) => {
    try {
      const { id, ...fields } = editAddressObj;
      const { data } = await apiClient.put(`/api/arizonaAddresses/${id}`, fields);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const createAddress = createAsyncThunk(
  'arizonaAddresses/createAddress',
  async (params, { rejectWithValue }) => {
    try {
      const { data } = await apiClient.post(`/api/arizonaAddresses`, params);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const resetEditAddressError = createAction('nevadaAddresses/resetEditAddressError', () => ({
  type: 'nevadaAddresses/resetEditAddressError',
}));

const initialState = {
  getAddress: {},
  editAddressError: null,
  addressId: null,
};

export const arizonaAddressesSlice = createSlice({
  name: 'arizonaAddresses',
  initialState,
  reducers: {},
  extraReducers: {
    [createAddress.fulfilled]: (state, action) => {
      state.addressId = action.payload.result;
    },
    [createAddress.rejected]: (state, action) => {
      state.error = action.payload;
    },
    [getAddress.fulfilled]: (state, action) => {
      const { result } = action.payload;
      const formattedResult = {
        ...result,
        ownerEntityRefs: result.ownerEntityRefs.map((item) => ({
          ...item,
          endDate: formatDate(item?.endDate, 'MM/DD/YYYY'),
          startDate: formatDate(item?.startDate, 'MM/DD/YYYY'),
        })),
      };

      state.getAddress = formattedResult;
    },
    [updateAddress.rejected]: (state, action) => {
      state.editAddressError = action.payload;
    },
    [resetEditAddressError]: (state) => {
      state.editAddressError = null;
    },
  },
});

export default arizonaAddressesSlice.reducer;
